var _ellipse, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 67,
    viewBox: "0 0 73 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 37.5,
    cy: 51.5,
    rx: 34.5,
    ry: 11.5,
    fill: "#D5EEFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.8839 7.11612C37.3957 6.62796 36.6043 6.62796 36.1161 7.11612L28.1612 15.0711C27.673 15.5592 27.673 16.3507 28.1612 16.8388C28.6493 17.327 29.4408 17.327 29.9289 16.8388L37 9.76777L44.0711 16.8388C44.5592 17.327 45.3507 17.327 45.8388 16.8388C46.327 16.3507 46.327 15.5592 45.8388 15.0711L37.8839 7.11612ZM38.25 58V8H35.75V58H38.25Z",
    fill: "#D5EEFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7071 7.29289C37.3166 6.90237 36.6834 6.90237 36.2929 7.29289L29.9289 13.6569C29.5384 14.0474 29.5384 14.6805 29.9289 15.0711C30.3195 15.4616 30.9526 15.4616 31.3431 15.0711L37 9.41422L42.6569 15.0711C43.0474 15.4616 43.6805 15.4616 44.0711 15.0711C44.4616 14.6805 44.4616 14.0474 44.0711 13.6569L37.7071 7.29289ZM38 58V8H36V58H38Z",
    fill: "#0593F5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrow);
export default __webpack_public_path__ + "static/media/icon_Arrow.803e3b7eef4a7ce0fc63a32fd69fdb20.svg";
export { ForwardRef as ReactComponent };